import { render } from "./RegistroDesdeCSV.vue?vue&type=template&id=7a9a8bc0&scoped=true"
import script from "./RegistroDesdeCSV.vue?vue&type=script&lang=js"
export * from "./RegistroDesdeCSV.vue?vue&type=script&lang=js"

import "./RegistroDesdeCSV.vue?vue&type=style&index=0&id=7a9a8bc0&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9a8bc0"]])

export default __exports__